import { QRCodeCanvas, QRCodeSVG } from 'qrcode.react';

/**
 * The only file that imports qrcode.react. Every QR code in the app goes
 * through this component, so swapping or upgrading the library is a
 * one-file change.
 */

// The Alliance "A" mark (assets/alliance/alliance-a.svg), 56×55 viewBox
const ALLIANCE_A_PATHS = [
  'M18.8 43.9C17.2 44.7 16.1 45 15.4 44.8C14.7 44.6 14.3 44 14.2 42.9C14.2 41.9 14.4 40.5 15 38.8C15.6 37.1 16.4 35.3 17.5 33.2C16.3 33.5 15.1 33.8 13.9 34C13.5 34.1 13.2 33.9 13.2 33.5C13.2 33.1 13.3 32.6 13.6 32C13.9 31.4 14.2 30.9 14.7 30.5C15.2 30 15.6 29.9 16.2 29.9C16.5 29.9 17 30 17.5 30C18.1 30 18.7 30 19.5 30C20.2 28.9 20.9 27.9 21.6 26.9C23 25.1 24.4 23.3 25.9 21.6C27.4 19.9 28.9 18.4 30.3 17C31.8 15.6 33.2 14.4 34.6 13.4C36 12.4 37.2 11.6 38.4 11C39.5 10.4 40.5 10.1 41.3 10C42.1 9.9 42.7 10 43 10.5C43.3 10.9 43.3 11.4 43.1 12.2C42.9 12.9 42.5 13.8 42 14.8C41.4 15.8 40.8 16.9 40 18.1C39.2 19.3 38.4 20.6 37.6 21.9C36.8 23.2 36 24.5 35.2 25.9C34.4 27.2 33.8 28.5 33.2 29.6C32.7 30.7 32.3 31.7 32.1 32.5C31.9 33.3 32 33.9 32.3 34.1C32.4 34.2 32.7 34.2 33.1 33.9C33.5 33.6 33.9 33.3 34.4 32.8C34.9 32.4 35.4 31.8 35.9 31.3C36.4 30.7 36.8 30.2 37.1 29.7C37.4 29.3 37.6 29 37.9 28.9C38.1 28.8 38.3 28.7 38.5 28.8C38.6 28.8 38.7 29 38.7 29.2C38.7 29.4 38.6 29.7 38.4 30.2C38.2 30.5 37.9 31 37.5 31.6C37.1 32.2 36.5 32.9 36 33.7C35.4 34.4 34.8 35.2 34.1 36C33.4 36.8 32.7 37.4 32.1 38C31.4 38.6 30.8 39 30.2 39.2C29.6 39.5 29.1 39.4 28.6 39.1C28.3 38.9 28.1 38.5 28.1 37.9C28.1 37.4 28.1 36.7 28.3 35.9C28.5 35.1 28.8 34.3 29.1 33.4C29.4 32.5 29.9 31.5 30.3 30.5C28.8 30.8 27.3 31.2 25.8 31.5C24.3 31.9 22.8 32.2 21.5 32.5C20.9 33.7 20.3 34.9 19.9 36.1C19.5 37.3 19.1 38.4 18.9 39.4C18.7 40.4 18.6 41.3 18.6 42.1C18.4 42.7 18.5 43.4 18.8 43.9ZM22.8 29.8C24.1 29.6 25.5 29.4 27 29.2C28.5 28.9 29.9 28.6 31.2 28.2C32 26.5 32.9 24.9 33.8 23.3C34.7 21.7 35.6 20.3 36.3 19C37 17.7 37.6 16.7 38 15.8C38.4 14.9 38.5 14.4 38.2 14.1C38 13.9 37.6 13.9 37.1 14C36.6 14.2 36 14.5 35.3 15C34.6 15.5 33.8 16.2 33 17C32.1 17.8 31.3 18.7 30.3 19.7C29.4 20.7 28.5 21.8 27.5 22.9C26.6 24.1 25.7 25.2 24.8 26.4C24.4 26.9 24 27.5 23.7 28C23.5 28.7 23.1 29.2 22.8 29.8Z',
  'M14.2 38.6C14.3 38.4 14.4 38.1 14.5 37.9C11.9 34.9 10.3 31 10.3 26.8C10.3 17.5 17.9 9.9 27.2 9.9C30.1 9.9 32.8 10.6 35.2 11.9C35.8 11.5 36.4 11.1 37 10.8C34.1 9 30.8 8 27.1 8C16.7 8 8.3 16.4 8.3 26.8C8.3 31.9 10.4 36.6 13.7 40C13.9 39.5 14.1 39 14.2 38.6Z',
  'M42.4 15.5C42.1 16.1 41.7 16.6 41.3 17.3C43.1 20 44.1 23.2 44.1 26.7C44.1 36 36.5 43.6 27.2 43.6C24.3 43.6 21.6 42.9 19.2 41.6C19.2 41.7 19.2 41.8 19.2 41.9C19.2 42.5 19.3 43 19.5 43.4L19.9 44C22.2 45 24.6 45.5 27.3 45.5C37.7 45.5 46.1 37.1 46.1 26.7C46.1 22.5 44.7 18.7 42.4 15.5Z',
];

/**
 * Build a data URL for the Alliance "A" in the given color, for the center
 * of a QR code
 */
const allianceMarkDataUrl = (params: { color: string }) => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 55" fill="${
    params.color
  }">${ALLIANCE_A_PATHS.map((d) => `<path d="${d}"/>`).join('')}</svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};

/**
 * Render a QR code.
 *
 * @param value - The text or URL to encode
 * @param size - Width and height in px
 * @param logoColor - When set, the Alliance "A" is drawn in the center in
 *   this color, and error correction is raised to H so the code still scans
 * @param renderAs - 'svg' (default) or 'canvas'. Use canvas where the code
 *   has to be printed or copied as an image, as Events does today
 * @param title - Accessible name for the code
 */
export function QrCode(props: {
  value: string;
  size: number;
  logoColor?: string;
  renderAs?: 'svg' | 'canvas';
  title?: string;
}) {
  // Props
  const { value, size, logoColor } = props;

  // The logo covers about a fifth of the code; level H tolerates ~30% loss
  const logoSize = Math.round(size * 0.22);
  const imageSettings = logoColor
    ? {
        src: allianceMarkDataUrl({ color: logoColor }),
        height: logoSize,
        width: logoSize,
        excavate: true,
      }
    : undefined;

  const shared = {
    value,
    size,
    // L matches qrcode.react's default, so existing codes render unchanged
    level: logoColor ? ('H' as const) : ('L' as const),
    marginSize: 0,
    title: props.title,
    imageSettings,
  };

  if (props.renderAs === 'canvas') {
    return <QRCodeCanvas {...shared} />;
  }
  return <QRCodeSVG {...shared} />;
}
